import { render } from "./EmailPage.vue?vue&type=template&id=32d990b0&scoped=true"
import script from "./EmailPage.vue?vue&type=script&lang=js"
export * from "./EmailPage.vue?vue&type=script&lang=js"

import "./EmailPage.vue?vue&type=style&index=0&id=32d990b0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d990b0"]])

export default __exports__